 <template>
  <div>
    <v-dialog v-model="single_update_tran" max-width="600" persistent>
      <v-card :loading="loading">
        <v-card-title class="headline">
          <v-col cols="11">Update Transaction </v-col>
          <v-col cols="1"
            ><v-btn icon>
              <v-icon size="28px" class="drag-icon">mdi-drag-variant</v-icon>
            </v-btn>
          </v-col>
        </v-card-title>
        <v-card-text>
          <v-row dense>
            <v-col cols="12">
              <v-checkbox
                dense
                v-model="update_transaction.update_locked_trans"
                hide-details
                label="Allow to update locked transaction"
                class="mt-0 pt-0"
              ></v-checkbox>
            </v-col>
            <!-- <v-col cols="12">
              <v-autocomplete
                dense
                :items="trans_type_list"
                v-model="update_transaction.trans_type_id"
                outlined
                hide-details
                label="Type"
                clearable
              ></v-autocomplete>
            </v-col> -->
            <v-col cols="4">
              <v-select
                :items="order_types"
                label="Status"
                dense
                outlined
                v-model="project_selected_status"
                @change="getProjectByStatus()"
                placeholder="All"
                hide-details
              ></v-select>
            </v-col>
            <v-col cols="8">
              <v-autocomplete
                dense
                :items="project_of_selected_status"
                v-model="update_transaction.project_id"
                outlined
                hide-details
                clearable
                label="Project"
                @change="
                  update_transaction.invoice_group_id = null;
                  update_transaction.invoice_item_id = null;
                  update_transaction.invoice_id = null;
                  getGroupOfProject();
                  getInvoiceList();
                "
              >
                <template v-slot:item="{ index, item }">
                  <div
                    v-if="item.text == 'No Project'"
                    class="v-list-item__content"
                  >
                    <div
                      class="v-list-item__title error--text"
                      style="font-size: 15px"
                    >
                      {{ item.text }}
                    </div>
                  </div>
                  <div v-else class="v-list-item__content">
                    <div class="v-list-item__title">{{ item.text }}</div>
                  </div>
                </template>
              </v-autocomplete>
            </v-col>
            <v-col cols="4">
              <v-select
                :items="order_types"
                label="Status"
                dense
                outlined
                v-model="vendor_selected_status"
                @change="getTransactionSelectors()"
                placeholder="All"
                hide-details
              ></v-select>
            </v-col>
            <v-col cols="8">
              <v-autocomplete
                dense
                :items="expence_list"
                v-model="update_transaction.vendor_id"
                outlined
                hide-details
                v-if="update_transaction.expence"
                clearable
                class="focus-on-vendor-expence3"
                label="Chart Of Account"
                @change="
                  update_transaction.invoice_group_id = null;
                  update_transaction.invoice_item_id = null;
                  update_transaction.invoice_id = null;
                  getGroupOfProject();
                "
              >
                <template v-slot:prepend-item>
                  <a
                    class="pl-4"
                    @click="
                      update_transaction.expence = false;
                      setFocus('focus-on-vendor-expence3');
                    "
                    >Select Vendor</a
                  >
                  <v-divider></v-divider>
                </template>
              </v-autocomplete>

              <v-autocomplete
                dense
                :items="vendor_list"
                v-model="update_transaction.vendor_id"
                outlined
                hide-details
                clearable
                label="Vendor"
                class="focus-on-vendor-expence3"
                @change="
                  update_transaction.invoice_group_id = null;
                  update_transaction.invoice_item_id = null;
                  update_transaction.invoice_id = null;
                  getGroupOfProject();
                "
                v-else
              >
                <template v-slot:prepend-item>
                  <a
                    class="pl-4"
                    @click="
                      update_transaction.expence = true;
                      setFocus('focus-on-vendor-expence3');
                    "
                    >Select Chart of Account</a
                  >
                  <v-divider></v-divider>
                </template>
              </v-autocomplete>
            </v-col>
            <v-col cols="12" style="display: content" v-if="!sales_income && selected_item && selected_item.project && selected_item.project.p_type=='fixed'">
              <v-row>
                <v-col cols="9">
                  <v-autocomplete
                    dense
                    :items="project_group_list"
                    v-model="update_transaction.invoice_group_id"
                    item-text="text"
                    item-value="value"
                    outlined
                    hide-details
                    clearable
                    label="Invoice Group"
                    @change="
                      update_transaction.invoice_item_id = null;
                      getItemOfGroup();
                      getGroupBalance();
                      update_transaction.invoice_group_id != null
                        ? (update_transaction.update_locked_trans = true)
                        : (update_transaction.update_locked_trans = false);
                    "
                  >
                    <template v-slot:item="{ item }">
                      <span style="width: 100%">
                        <span>{{ item.text }}</span>
                        <span class="float-right pl-2">
                          <span class="primary--text" v-if="item.balance >= 0"
                            >${{ getAmountFormat(item.balance) }}</span
                          >
                          <span class="error--text" v-if="item.balance < 0"
                            >${{ getAmountFormat(item.balance) }}</span
                          >
                        </span>
                      </span>
                    </template>
                  </v-autocomplete>
                </v-col>
                <v-col cols="3">
                  <v-checkbox
                    dense
                    v-model="check_all_group"
                    hide-details
                    label="All Group"
                    class="mt-0 pt-0"
                    @click="getGroupOfProject()"
                  ></v-checkbox>
                </v-col>
              </v-row>
              <v-row>
                <v-col
                  cols="3"
                  v-if="
                    update_transaction.invoice_group_id && group_balance_data[0]
                  "
                  ><b>Cost</b><br />${{
                    group_balance_data[0] ? group_balance_data[0].cost : ""
                  }}</v-col
                >
                <v-col
                  cols="3"
                  v-if="
                    update_transaction.invoice_group_id && group_balance_data[0]
                  "
                  ><b>Balance</b><br />$<span ref="groupAmount">{{
                    group_balance_data[0] ? group_balance_data[0].balance : ""
                  }}</span>
                  <v-icon
                    class="ml-2"
                    size="20px"
                    @click="
                      copyGroupAmount(
                        group_balance_data[0]
                          ? group_balance_data[0].balance
                          : ''
                      )
                    "
                  >
                    mdi-content-copy
                  </v-icon></v-col
                >
                <v-col
                  cols="3"
                  v-if="
                    update_transaction.invoice_group_id && group_balance_data[0]
                  "
                  ><b>Money spent</b><br /><span
                    :class="getMoneySpent < 0 ? 'error--text' : 'primary--text'"
                    >${{ getAmountFormat(getMoneySpent) }}</span
                  ></v-col
                >
                <v-col
                  cols="3"
                  v-if="
                    update_transaction.invoice_group_id && group_balance_data[0]
                  "
                >
                  <b>Balance to Spend</b> <br />
                  <span class="primary--text" v-if="getBalanceToSpand >= 0"
                    >${{ getAmountFormat(getBalanceToSpand) }}</span
                  >
                  <span class="error--text" v-if="getBalanceToSpand < 0"
                    >${{ getAmountFormat(getBalanceToSpand) }}</span
                  >
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="9">
                  <v-autocomplete
                    dense
                    :items="project_item_list"
                    v-model="update_transaction.invoice_item_id"
                    item-text="text"
                    item-value="value"
                    outlined
                    hide-details
                    clearable
                    label="Invoice Item"
                    @change="getItemBalance()"
                  >
                    <template v-slot:item="{ item }">
                      <span style="width: 100%">
                        <span>{{ item.text }}-<span style="font-size:12px;">({{ item.area }})</span></span>
                        <span class="float-right pl-2">
                          <span class="primary--text" v-if="item.balance >= 0"
                            >${{ getAmountFormat(item.balance) }}</span
                          >
                          <span class="error--text" v-if="item.balance < 0"
                            >${{ getAmountFormat(item.balance) }}</span
                          >
                        </span>
                      </span>
                    </template>
                  </v-autocomplete>
                </v-col>
                <v-col cols="3">
                  <v-text-field
                    dense
                    outlined
                    v-model="split_amount"
                    type="number"
                    label="Split Amount"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col
                  cols="3"
                  v-if="
                    update_transaction.invoice_group_id && item_balance_data[0]
                  "
                  ><b>Cost</b><br />${{
                    item_balance_data[0] ? item_balance_data[0].cost : ""
                  }}</v-col
                >
                <v-col
                  cols="3"
                  v-if="
                    update_transaction.invoice_group_id && item_balance_data[0]
                  "
                  ><b>Balance</b><br />$<span ref="itemAmount">{{
                    item_balance_data[0] ? item_balance_data[0].balance : ""
                  }}</span>
                  <v-icon
                    class="ml-2"
                    size="20px"
                    @click="
                      copyItemAmount(
                        item_balance_data[0] ? item_balance_data[0].balance : ''
                      )
                    "
                  >
                    mdi-content-copy
                  </v-icon></v-col
                >
                <v-col
                  cols="3"
                  v-if="
                    update_transaction.invoice_group_id && item_balance_data[0]
                  "
                  ><b>Money spent</b><br /><span
                    :class="
                      getItemMoneySpent < 0 ? 'error--text' : 'primary--text'
                    "
                    >${{ getAmountFormat(getItemMoneySpent) }}</span
                  ></v-col
                >
                <v-col
                  cols="3"
                  v-if="
                    update_transaction.invoice_group_id && item_balance_data[0]
                  "
                >
                  <b>Balance to Spend</b> <br />
                  <span class="primary--text" v-if="getItemBalanceToSpand >= 0"
                    >${{ getAmountFormat(getItemBalanceToSpand) }}</span
                  >
                  <span class="error--text" v-if="getItemBalanceToSpand < 0"
                    >${{ getAmountFormat(getItemBalanceToSpand) }}</span
                  >
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12" style="display: content" v-if="!sales_income && selected_item && selected_item.project && selected_item.project.p_type=='cost_plus'">
              <v-row>
                <v-col cols="12">
                  <v-autocomplete
                    dense
                    :items="project_group_list"
                    v-model="update_transaction.invoice_group_id"
                    item-text="text"
                    item-value="value"
                    outlined
                    hide-details
                    clearable
                    label="Invoice Group"
                  >
                    <template v-slot:item="{ item }">
                      <span style="width: 100%">
                        <span>{{ item.text }}</span>
                      </span>
                    </template>
                  </v-autocomplete>
                </v-col>
                <!-- <v-col cols="3">
                  <v-checkbox
                    dense
                    v-model="check_all_group"
                    hide-details
                    label="All Group"
                    class="mt-0 pt-0"
                    @click="getGroupOfProject()"
                  ></v-checkbox>
                </v-col> -->
              </v-row>          
            </v-col>
            <v-col style="display: content" v-if="sales_income">
                <v-row>
                  <v-col cols="9" v-if="sales_income">
                    <v-autocomplete
                      dense
                      :items="project_invoice_list"
                      v-model="update_transaction.invoice_id"
                      item-text="invoice_number"
                      item-value="generated_inv_id"
                      outlined
                      hide-details
                      clearable
                      label="Invoice List"
                      @change="getInvoiceBalance();"
                    >
                    <template v-slot:item="{ item }">
                        <span style="width: 100%">
                          <span>{{ item.invoice_number }} - ( {{item.invoice_date}} )</span>
                          <span class="float-right pl-2">
                            <span class="primary--text" v-if="item.balance >= 0"
                              >${{ getAmountFormat(item.balance) }}</span
                            >
                            <span class="error--text" v-if="item.balance < 0"
                              >${{ getAmountFormat(item.balance) }}</span
                            >
                          </span>
                        </span>
                      </template>
                    </v-autocomplete>
                  </v-col>
                  <v-col cols="3">
                    <v-text-field
                      dense
                      outlined
                      v-model="split_amount"
                      type="number"
                      label="Split Amount"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                <v-col
                  cols="3"
                  v-if="
                    update_transaction.invoice_id && invoice_balance_data[0]
                  "
                  ><b>Invoice Amount</b><br />
                  <p :class="invoice_balance_data[0].amount < 0 ? 'error--text' : 'primary--text'">${{invoice_balance_data[0] ? getAmountFormat(invoice_balance_data[0].amount) : "" }}</p>
                </v-col>
                <v-col
                  cols="3"
                  v-if="
                    update_transaction.invoice_id && invoice_balance_data[0]
                  "><b>Invoice Balance</b><br /><p :class="invoice_balance_data[0].balance < 0 ? 'error--text' : 'primary--text'">
                    $<span ref="invoiceAmount">{{invoice_balance_data[0] ? getAmountFormat(invoice_balance_data[0].balance) : ""}}</span>
                    <v-icon
                    class="ml-2"
                    size="20px"
                    @click="
                      copyInvoiceAmount(invoice_balance_data[0]? getAmountFormat(invoice_balance_data[0].balance)  : '')">
                    mdi-content-copy
                  </v-icon>
                  </p>
                </v-col
                >
                <v-col
                  cols="3"
                  v-if="
                    update_transaction.invoice_id && invoice_balance_data[0]
                  "
                  ><b>Money Received</b><br /><span
                    :class="getInvoiceMoneySpent < 0 ? 'error--text' : 'primary--text'"
                    >${{ getAmountFormat(getInvoiceMoneySpent) }}</span
                  ></v-col
                >
                <v-col
                  cols="3"
                  v-if="
                    update_transaction.invoice_id && invoice_balance_data[0]
                  "
                >
                  <b>Balance Due</b> <br />
                  <span class="primary--text" v-if="getInvoiceBalanceToSpand >= 0"
                    >${{ getAmountFormat(getInvoiceBalanceToSpand) }}</span
                  >
                  <span class="error--text" v-if="getInvoiceBalanceToSpand < 0"
                    >${{ getAmountFormat(getInvoiceBalanceToSpand) }}</span
                  >
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12">
              <v-menu
                v-model="transaction_date2"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="update_transaction.transaction_date"
                    label="Transaction Date"
                    :disabled="update_transaction.is_lock_by_current_date == 1"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    dense
                    hide-details
                    outlined
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="dateFormatted"
                  @input="
                    transaction_date2 = false;
                    parseDate3();
                  "
                  no-title
                  scrollable
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12">
              <v-autocomplete
                label="Bank"
                :disabled="update_transaction.is_lock_by_current_date == 1"
                :items="banks"
                v-model="update_transaction.bank_id"
                :error-messages="update_transaction_error.bank_id"
                :hide-details="!update_transaction_error.bank_id"
                item-text="bank_name"
                item-value="bank_id"
                outlined
                clearable
                dense
              ></v-autocomplete>
            </v-col>
            <v-col cols="12">
              <v-textarea
                label="Description"
                v-model="update_transaction.description"
                hide-details
                outlined
                clearable
                rows="2"
                dense
              ></v-textarea>
            </v-col>
            <v-col cols="5" class="d-flex align-center">
              <v-radio-group
                v-model="update_transaction.amount_type"
                row
                hide-details
                class="mt-0"
                dense
                :disabled="update_transaction.is_lock_by_current_date == 1"
              >
                <v-radio color="primary" value="PLUS" class="ma-0 pa-0">
                  <template v-slot:label>
                    <div class="primary--text">Cr</div>
                  </template>
                </v-radio>
                <v-radio
                  label="Dr"
                  color="error"
                  value="MINUS"
                  class="ma-0 pa-0 pl-2"
                >
                  <template v-slot:label>
                    <div class="error--text">Dr</div>
                  </template>
                </v-radio>
              </v-radio-group>
            </v-col>
            <v-col cols="7">
              <v-text-field
                label="Amount"
                v-model="update_transaction.amount"
                hide-details
                type="number"
                :disabled="update_transaction.is_lock_by_current_date == 1"
                :color="
                  update_transaction.amount_type == 'MINUS'
                    ? 'error'
                    : 'primary'
                "
                :class="
                  update_transaction.amount_type == 'MINUS'
                    ? 'red-font-color'
                    : 'green-font-color'
                "
                outlined
                dense
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-btn color="error" @click="closePopup()">Cancel</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="error" v-if="selected_item.childs_count==0 && selected_item.split_from_id!=null" @click="deleteTransactions()">Delete</v-btn>
          <v-btn color="error" @click="setDefaultData()">Reset</v-btn>
          <v-btn
            color="primary"
            :disabled="loading ||(!sales_income &&(selected_item.generated_inv_id ||getItemBalanceToSpand < 0 ||  getBalanceToSpand < 0 ||  parseFloat(split_amount) >  parseFloat(update_transaction.amount) ||split_amount == 0)) 
            ||
              (sales_income &&(parseFloat(split_amount) >  parseFloat(update_transaction.amount) ||split_amount == 0 || getInvoiceBalanceToSpand > 0))"
            @click="parseFloat(split_amount) == parseFloat(update_transaction.amount)  ? updateSingleTransaction(): splitTransaction()"
          >
            {{
              parseFloat(split_amount) == parseFloat(update_transaction.amount)
                ? "Update"
                : "Split"
            }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
 <script>
import axios from "../../plugins/axios";
import { parseParams } from "../../plugins/helper";
import { mapMutations } from "vuex";
export default {
  data() {
    return {
      loading: false,
      check_all_group: true,
      project_of_selected_status: [],
      project_selected_status: "all",
      vendor_selected_status :"all",
      transaction_date2: false,
      project_group_list: [],
      project_item_list: [],
      project_invoice_list: [],
      update_transaction: {
        trans_type_id: null,
        update_locked_trans: false,
        project_id: null,
        invoice_group_id: null,
        vendor_id: null,
        expence: false,
        transaction_date: null,
        amount_type: "PLUS",
        amount: null,
        bank_id: null,
        description: null,
        invoice_item_id: null,
        invoice_id: null,
      },
      split_amount: "0",
      keywords: {
        item: null,
        vendors: [],
        expences: [],
        project: [],
        invoice_group: [],
        type: [],
        info: {},
      },
      trans_type_list: [],
      expence_list: [],
      item_list: [],
      vendor_list: [],
      banks: [],
      dateFormatted: null,
      group_balance_data: [],
      item_balance_data: [],
      invoice_balance_data:[],
      update_transaction_error: {},
      sales_income: false,
      order_types: [
        { text: "All", value: "all" },
        { text: "Active", value: "1" },
        { text: "Inactive", value: "0" },
      ],
    };
  },
  props: ["single_update_tran", "selected_item"],
  watch: {
    single_update_tran: function (value) {
      this.sales_income = false;
      this.project_invoice_list = [];
      this.update_transaction.invoice_id = null;
      if (value) {
        console.log('selected_item', this.selected_item);
        if (      
          this.selected_item.expence == true &&
          this.selected_item.vendor_id == "35"
        ) {
          this.sales_income = true;
          this.getInvoiceList();
        }

        this.check_all_group = true;
        this.group_balance_data = [];
        this.setDefaultData();
        this.getGroupOfProject();
        this.getInvoiceList();
        this.getProjectByStatus();
        this.getTransactionSelectors();
        this.getKeywords(this.selected_item);
      }
    },
  },
  computed: {
    getMoneySpent() {
      if (this.group_balance_data[0] && this.selected_item && this.selected_item.project &&  this.selected_item.project.p_type=='fixed') {
        let money_spent;
        if (this.update_transaction.amount_type == "MINUS") {
          money_spent =
            parseFloat(this.group_balance_data[0].money_spent) -
            (this.split_amount ? parseFloat(this.split_amount) : "0");
        } else {
          money_spent =
            parseFloat(this.group_balance_data[0].money_spent) +
            (this.split_amount ? parseFloat(this.split_amount) : "0");
        }
        let grp_id = this.update_transaction.invoice_group_id.split("-");
        if (grp_id[1] == this.selected_item.invoice_group_id) {
          money_spent =
            parseFloat(money_spent) - parseFloat(this.selected_item.rev_amount);
        }
        return money_spent.toFixed(2);
      } else {
        return "";
      }
    },
    getBalanceToSpand() {
      if (this.group_balance_data[0] && this.selected_item && this.selected_item.project &&  this.selected_item.project.p_type=='fixed') {
        let balance;
        balance =
          parseFloat(this.group_balance_data[0].cost) +
          parseFloat(this.getMoneySpent);
        return balance.toFixed(2);
      } else {
        return "";
      }
    },
    getItemMoneySpent() {
      if (this.item_balance_data[0] && this.selected_item && this.selected_item.project &&  this.selected_item.project.p_type=='fixed') {
        let money_spent_item;
        if (this.update_transaction.amount_type == "MINUS") {
          money_spent_item =
            parseFloat(this.item_balance_data[0].money_spent) -
            (this.split_amount ? parseFloat(this.split_amount) : "0");
        } else {
          money_spent_item =
            parseFloat(this.item_balance_data[0].money_spent) +
            (this.split_amount ? parseFloat(this.split_amount) : "0");
        }
        if (
          this.update_transaction.invoice_item_id ==
          this.selected_item.invoice_item_id
        ) {
          money_spent_item =
            parseFloat(money_spent_item) -
            parseFloat(this.selected_item.rev_amount);
        }
        return money_spent_item.toFixed(2);
      } else {
        return "";
      }
    },
    getItemBalanceToSpand() {
      if (this.item_balance_data[0] && this.selected_item && this.selected_item.project &&  this.selected_item.project.p_type=='fixed') {
        let balance_item;
        balance_item =
          parseFloat(this.item_balance_data[0].cost) +
          parseFloat(this.getItemMoneySpent);
        return balance_item.toFixed(2);
      } else {
        return "";
      }
    },
    getInvoiceMoneySpent() {
      if (this.invoice_balance_data[0]) {
        let money_spent;
        if (this.update_transaction.amount_type == "MINUS") {
          money_spent =
            parseFloat(this.invoice_balance_data[0].money_spent) -
            (this.split_amount ? parseFloat(this.split_amount) : "0");
        } else {
          money_spent =
            parseFloat(this.invoice_balance_data[0].money_spent) +
            (this.split_amount ? parseFloat(this.split_amount) : "0");
        }
        let invoice_id = this.update_transaction.invoice_id;
        if (invoice_id == this.selected_item.generated_inv_id) {
          money_spent =
            parseFloat(money_spent) - parseFloat(this.selected_item.rev_amount);
        }
        return money_spent.toFixed(2);
      } else {
        return "";
      }
    },
    getInvoiceBalanceToSpand() {
      if (this.invoice_balance_data[0]) {
        let balance;
        balance =
          parseFloat(this.invoice_balance_data[0].amount) +
          parseFloat(this.getInvoiceMoneySpent);
        return balance.toFixed(2);
      } else {
        return "";
      }
    },
  },
  components: {},
  methods: {
    ...mapMutations("utils", ["setAlert"]),
    copyGroupAmount(amount) {
      this.selectText(this.$refs.groupAmount); // e.g. <div ref="text">
      document.execCommand("copy");
      this.split_amount = amount;
    },
    copyItemAmount(amount) {
      this.selectText(this.$refs.itemAmount); // e.g. <div ref="text">
      document.execCommand("copy");
      this.split_amount = amount;
    },
    copyInvoiceAmount(amount) {
      this.selectText(this.$refs.invoiceAmount); // e.g. <div ref="text">
      document.execCommand("copy");
      this.split_amount = amount;
    },
    selectText(element) {
      var range;
      if (document.selection) {
        // IE
        range = document.body.createTextRange();
        range.moveToElementText(element);
        range.select();
      } else if (window.getSelection) {
        range = document.createRange();
        range.selectNode(element);
        window.getSelection().removeAllRanges();
        window.getSelection().addRange(range);
      }
    },
    getGroupBalance() {
      this.group_balance_data = this.project_group_list.filter((item) => {
        if (item.value == this.update_transaction.invoice_group_id) {
          return item;
        }
      });
    },
    getInvoiceBalance(){
      console.log('testtt');
      this.invoice_balance_data =this.project_invoice_list.filter((item)=>{
        console.log('generated_inv_id',item.generated_inv_id);
        console.log('invoice_id',this.update_transaction.invoice_id);
        if(item.generated_inv_id == this.update_transaction.invoice_id){
          return item;
        }
        console.log('this.invoice_balance_data ',this.invoice_balance_data );

      })
    },
    getItemBalance() {
      this.item_balance_data = this.project_item_list.filter((item) => {
        if (item.value == this.update_transaction.invoice_item_id) {
          return item;
        }
      });
    },
    getItemOfGroup() {
      let _self = this;
      this.loading = true;
      axios
        .get(
          "get_item_of_group_with_balance?project_id=" +
            this.update_transaction.project_id +
            "&project_data_id=" +
            this.update_transaction.invoice_item_id +
            "&vendor_id=" +
            this.update_transaction.vendor_id +
            "&group_id=" +
            this.update_transaction.invoice_group_id +
            "&check_all_group=" +
            this.check_all_group +
            "&amount_type=" +
            this.update_transaction.amount_type
        )
        .then((response) => {
          if (response.data.status) {
            _self.project_item_list = response.data.data;
            _self.project_item_list = _self.project_item_list.filter((item) => {
              if (
                item.balance != 0.0 ||
                _self.selected_item.invoice_item_id == item.value
              ) {
                return item;
              }
            });
          }
          _self.loading = false;
          _self.getItemBalance();
        })
        .catch(function () {});
    },
    getInvoiceList() {
      let _self = this;
      this.loading = true;
      axios
        .get(
          "get_project_invoice_list_with_balance?project_id=" +
            this.update_transaction.project_id
        )
        .then((response) => {
          _self.project_invoice_list = response.data.invoice_list;
          _self.project_invoice_list = _self.project_invoice_list.filter((item)=>{
            if(item.balance != 0.00 || _self.selected_item.generated_inv_id == item.generated_inv_id){
              return item;
            }
          })
          _self.project_item_list = _self.project_item_list.filter((item) => {
              if (
                item.balance != 0.0 ||
                _self.selected_item.invoice_item_id == item.value
              ) {
                return item;
              }
            });

          _self.loading = false;
          _self.getInvoiceBalance();
        })
        .catch(function (error) {
          console.log(error);
          _self.loading = false;
        });
    },
    getGroupOfProject() {
      let _self = this;
      this.loading = true;
      axios
        .get(
          "get_group_of_project_with_balance?project_id=" +
            this.update_transaction.project_id +
            "&vendor_id=" +
            this.update_transaction.vendor_id +
            "&check_all_group=" +
            this.check_all_group +
            "&amount_type=" +
            this.update_transaction.amount_type
        )
        .then((response) => {
          if (response.data.status) {
            _self.project_group_list = response.data.data;
            console.log("_self.project_group_list", _self.project_group_list);
            _self.project_group_list = _self.project_group_list.filter(
              (item) => {
                let grp_cha = item.value;
                let val = grp_cha.split("-");
                if (
                  item.balance != 0.0 ||
                  (_self.selected_item.invoice_group_id == val[1] &&
                    _self.selected_item.change_order == val[0])
                ) {
                  return item;
                }
              }
            );
            _self.getGroupBalance();
            _self.getItemOfGroup();
          }
          _self.loading = false;
        })
        .catch(function () {});
    },
    updateSingleTransaction() {
      let _self = this;
      this.loading = true;
      this.update_transaction_error = {};
      
      let company_data = localStorage.getItem("company_data");
      company_data = JSON.parse(company_data);
      _self.update_transaction.company_id=company_data.company_id
      axios
        .post("edit_transaction", this.update_transaction)
        .then(function (response) {
          let data = response.data;
          if (!data.status) {
            for (let key in data.errors) {
              _self.update_transaction_error[key] = data.errors[key][0];
            }
          } else {
            if (response.data.display_success_msg) {
              _self.setAlert({
                show: true,
                variant: "primary",
                message: response.data.message,
                dismissCountDown: 0,
              });
            }
            _self.$emit("updateValue");
            // axios
            // .post("set_keywords", _self.keywords)
            // .then(function(res) {
            //   let data = res.data;
            //   if (data.status) {
            //     _self.keywords.item = null;
            //     _self.keywords.vendors = [];
            //     _self.keywords.expences = [];
            //     _self.keywords.invoice_group = [];
            //     _self.keywords.project = [];
            //     _self.keywords.type = [];
            //     _self.keywords.info = {};
            //     _self.$emit('updateValue');
            //   }
            // })
            // .then(function() {
            // });
          }
          _self.loading = false;
        })
        .catch(function () {
          _self.loading = false;
        });
    },
    splitTransaction() {
      let _self = this;
      let sData = {};
      sData.trans_id = this.update_transaction.id;
      sData.amount = _self.split_amount;
      sData.invoice_item_id = this.update_transaction.invoice_item_id;
      sData.invoice_group_id = this.update_transaction.invoice_group_id;
      sData.invoice_id = this.update_transaction.invoice_id;
      sData.for_item_balance = true;
      axios
        .post("split_transaction", sData)
        .then(function (response) {
          if (response.data.status) {
            _self.setAlert({
              show: true,
              variant: "primary",
              message: response.data.message,
              dismissCountDown: 0,
            });
            _self.$emit("updateValue");
          } else {
            // for (let key in response.data.errors) {
            //   _self.split_amount_error = response.data.errors[key][0];
            // }
          }
        })
        .catch(function () {
          console.log("FAILURE!!");
        });
    },
    setDefaultData() {
      this.update_transaction_error = {};
      this.update_transaction.id = this.selected_item.trans_id;
      this.update_transaction.trans_type_id = this.selected_item.trans_type_id;
      this.update_transaction.update_locked_trans = false;
      this.update_transaction.project_id = this.selected_item.project_id;
      this.update_transaction.invoice_group_id =
        this.selected_item.change_order +
        "-" +
        this.selected_item.invoice_group_id;
      console.log(
        "  this.update_transaction.invoice_group_id",
        this.update_transaction.invoice_group_id
      );
      this.update_transaction.vendor_id = this.selected_item.vendor_id;
      this.update_transaction.invoice_item_id =
        this.selected_item.invoice_item_id;
      this.update_transaction.expence = this.selected_item.expence;
      this.update_transaction.description = this.selected_item.description;
      this.update_transaction.is_lock_by_current_date =
        this.selected_item.is_lock_by_current_date;
      this.update_transaction.invoice_id = this.selected_item.generated_inv_id;
      this.dateFormatted = this.selected_item.trans_date;
      this.parseDate3();
      if (this.selected_item.rev_amount < 0) {
        this.update_transaction.amount_type = "MINUS";
      } else {
        this.update_transaction.amount_type = "PLUS";
      }
      this.update_transaction.amount = this.getAmountFormat(
        this.selected_item.rev_amount
      );
      this.update_transaction.bank_id = this.selected_item.bank_id;
      this.project_selected_status=this.selected_item.project_id=='' ? '1' : 'all';
      this.vendor_selected_status=this.selected_item.vendor_id=='' ? '1' : 'all';
      // this.project_selected_status = "all";
      this.split_amount = this.update_transaction.amount;
    },
    closePopup() {
      this.$emit("closePopup");
    },
    getAmountFormat(value) {
      if (value) {
        return value.replace("-", "");
      } else {
        return 0;
      }
    },
    getKeywords(item) {
      let _self = this;
      this.keywords.item = item;
      this.loading = true;
      axios
        .get("get_keywords?" + parseParams(item))
        .then(function (res) {
          let data = res.data;
          if (data.status) {
            _self.keywords.vendors = data.data.keywords.vendor;
            _self.keywords.expences = data.data.keywords.expence;
            _self.keywords.project = data.data.keywords.project;
            _self.keywords.invoice_group = data.data.keywords.invoice_group;
            _self.keywords.type = data.data.keywords.type;
            _self.keywords.info = data.data.keywords.info;
          }
          _self.loading = false;
        })
        .then(function () {
          _self.loading = false;
        });
    },
    getTransactionSelectors() {
      let _self = this;
      this.loading = true;
      axios
        .get("update_transaction_data?status=" + this.vendor_selected_status)
        .then((response) => {
          if (response.data.status) {
            _self.trans_type_list = response.data.data.trans_types;
            _self.expence_list = response.data.data.expences;
            _self.item_list = response.data.data.items;
            _self.vendor_list = response.data.data.vendors;
            _self.banks = response.data.data.banks;
          }
          _self.loading = false;
        })
        .catch(function () {});
    },
    parseDate3() {
      const [year, month, day] = this.dateFormatted.split("-");
      this.update_transaction.transaction_date = `${month.padStart(
        2,
        "0"
      )}/${day.padStart(2, "0")}/${year}`;
    },
    setFocus(className) {
      document.querySelectorAll("." + className + " input")[0].focus();
    },
    getProjectByStatus() {
      let _self = this;
      this.loading = true;
      axios
        .get("get_project_by_status?status=" + this.project_selected_status)
        .then((response) => {
          if (response.data.status) {
            _self.project_of_selected_status = response.data.data;
          }
          _self.loading = false;
        })
        .catch(function () {
          _self.loading = false;
        });
    },
      deleteTransactions() {
      this.loading = true;
      let _self = this;
      let ids = [];
      ids.push(_self.selected_item.trans_id);
      let company_data = localStorage.getItem("company_data");
      company_data = JSON.parse(company_data);
      axios
        .post("delete_transaction", {
          ids: ids,
          company_id: company_data.company_id,
          is_from_split_delete:_self.update_transaction.update_locked_trans==true ? true : false

        })
        .then(function(response) {
          _self.setAlert({
            show: true,
            variant: "primary",
            message: response.data.message,
            dismissCountDown: 0
          });
          _self.$emit("updateValue");
          _self.loading = false;
        })
        .catch(function() {
          _self.loading = false;
          console.log("FAILURE!!");
        });
    },
  },
  created: function () {},
  mounted: function () {},
};
</script>